import { Directive, input } from "@angular/core";

// Centralizes the `data-updated-fade` class binding (see src/styles/_animations.scss) so
// every cache-first page shares one place to bind/adjust the background-refresh flash effect.
@Directive({
  selector: "[appDataUpdatedFade]",
  standalone: true,
  host: {
    "[class.data-updated-fade]": "appDataUpdatedFade()"
  }
})
export class DataUpdatedFadeDirective {
  readonly appDataUpdatedFade = input<boolean>(false);
}
